import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function DepositoryParticipantAudit() {
  const [activeTab, setActiveTab] = useState("depository");
  const navigate = useNavigate();

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/Achievements.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Depository Participant (DP) Audit – NSDL/CDSL</h1>
          <p>
            Ensuring compliance and operational integrity for Depository
            Participants under NSDL & CDSL regulations.
          </p>
        </div>
      </section>

      {/* ✅ SAME TAB NAVIGATION */}
      <div className="tax-tabs">
        <button
          className={activeTab === "capital" ? "active" : ""}
          onClick={() => handleTabClick("capital", "/capital-market-sebi")}
        >
          Capital Market & SEBI Advisory
        </button>

        <button
          className={activeTab === "depository" ? "active" : ""}
          onClick={() =>
            handleTabClick("depository", "/depository-participant-audit")
          }
        >
          Depository Participant (DP) Audit – NSDL/CDSL
        </button>

        <button
          className={activeTab === "system" ? "active" : ""}
          onClick={() =>
            handleTabClick("system", "/system-audit-capital-market")
          }
        >
          System Audit for Capital Market Intermediaries
        </button>

        <button
          className={activeTab === "exchange" ? "active" : ""}
          onClick={() =>
            handleTabClick("exchange", "/exchange-sebi-compliances")
          }
        >
          Exchange & SEBI Compliances
        </button>

        <button
          className={activeTab === "ipo" ? "active" : ""}
          onClick={() => handleTabClick("ipo", "/ipo-listing-support")}
        >
          IPO & Listing Support
        </button>
      </div>

      {/* ===== SERVICE DETAILS SECTION ===== */}
      {/* ===== SERVICE DETAILS (Bootstrap Based Premium Design) ===== */}
      <section className="container dp-section">
        {/* INTRO BLOCK */}
        <div className="row">
          <div className="col-md-12 mt-5">
            {/* <div className="dp-card"> */}
            <h2 className="section-title mb-4">
              Depository Participant (DP) Audit – NSDL / CDSL
            </h2>
            <p className="service-text">
              Depository Participants (DPs) form the backbone of India’s
              securities settlement ecosystem. They act as the operational link
              between investors and the two major depositories — NSDL and CDSL.
              Ensuring compliance in DP operations is essential to protect
              investor interests, maintain accurate records, and adhere to SEBI
              regulations.
            </p>
            <p className="service-text mt-3">
              At <strong>S D P M & Co.</strong>, we conduct comprehensive DP
              Audits as mandated by SEBI and depositories. Our audits detect
              operational gaps, ensure legal compliance, and strengthen internal
              processes — helping intermediaries avoid penalties and build
              investor trust.
            </p>
          </div>
        </div>
        {/* </div> */}

        {/* SECTION TITLE */}
        <h3 className="dp-section-title mt-4">Our DP Audit Coverage</h3>

        {/* CARD 1 */}
        <div className="row">
          <div className="col-md-6">
            <div className="dp-card">
              <h4>1. KYC & Account Opening Compliance</h4>
              <ul>
                <li>Verification of Account Opening Forms (AOF)</li>
                <li>Checking PAN, Aadhaar & address proofs</li>
                <li>Review of IPV (In-Person Verification) records</li>
                <li>FATCA / UBO declaration verification</li>
                <li>CKYC compliance checks</li>
              </ul>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>2. Demat / Remat, Pledge & Hypothecation Audit</h4>
              <ul>
                <li>
                  Verification of dematerialisation & rematerialisation requests
                </li>
                <li>Pledge creation, invocation & release reviews</li>
                <li>Audit of hypothecation transactions</li>
                <li>Timeliness & correctness of authorisation</li>
              </ul>
            </div>
          </div>
        </div>

        {/* CARD 3 */}
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="dp-card">
              <h4>3. POA, Ledger & Transaction Review</h4>
              <ul>
                <li>Verification of POA documentation</li>
                <li>Monitoring misuse of POA</li>
                <li>Client ledger review & reconciliation</li>
                <li>Validation of debit/credit transactions</li>
                <li>Verification with depository statements</li>
              </ul>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>4. BO Account Reconciliation & Record Verification</h4>
              <ul>
                <li>Dormant & inactive account review</li>
                <li>Verification of BO account balances</li>
                <li>Review of closure & transmission cases</li>
                <li>Reconciliation of system records vs depository data</li>
              </ul>
            </div>
          </div>
        </div>

        {/* CARD 5 - FULL WIDTH */}
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="dp-card">
              <h4>5. Reporting of Non-Compliance & Corrective Actions</h4>
              <ul>
                <li>Detailed reporting on deviations & non-compliance</li>
                <li>Documentation and operational gap findings</li>
                <li>Recommendations for corrective measures</li>
                <li>Support in implementing controls and rectification</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      {/* <div className="row mt-4">
        <div className="col-md-12">
          <div className="nri-highlight">
            <h3 className="mb-3"> Why Choose Us?</h3>
            <ul>
              <li>Expert team with deep NSDL/CDSL operational knowledge</li>
              <li>End-to-end audit, advisory & compliance support</li>
              <li>Easy-to-understand, professional audit reports</li>
              <li>Strong focus on internal control enhancement</li>
              <li>100% confidentiality & regulatory accuracy</li>
            </ul>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
}
